<div class="w-100 gap-27px grid cols-1fr-1fr-collapse">
  <div class="w-100 flex column gap-27px">
    <div>
      <div class="light-text">
        {{ 'profiles.edit.billing.revenue-item' | translate | titlecase }}
      </div>
      <div>
        <select class="form-control" [(ngModel)]="value.ItemNum" (change)="revenueItemChanged($event.target.value)"
          [disabled]="isLegacyArb">
          <option value="0">{{ 'common.select' | translate | titlecase }}</option>
          <option *ngFor="let revenueItem of revenueItems" [value]="revenueItem.ItemNum">{{ revenueItem.ItemName }}
          </option>
        </select>
      </div>
    </div>
    <div class="flex row-collapse gap-sm-5px">
      <div class="mr-10">
        <div class="light-text">{{ 'profiles.edit.billing.anchor-month' | translate | titlecase }}</div>
        <select class="form-control" [(ngModel)]="value.AnchorMonth" (change)="anchorChanged()"
          [disabled]="isLegacyArb">
          <option value="0">{{ 'common.select' | translate | titlecase }}</option>
          <option *ngFor="let month of months; let i = index" [value]="i + 1">{{ month }}</option>
        </select>
      </div>
      <div class="mr-10">
        <div class="light-text">{{ 'profiles.edit.billing.anchor-day' | translate | titlecase }}</div>
        <select class="form-control" [(ngModel)]="value.AnchorDay" (change)="anchorChanged()" [disabled]="isLegacyArb">
          <option value="0">{{ 'common.select' | translate | titlecase }}</option>
          <option *ngFor="let anchorDay of anchorDays" [value]="anchorDay">{{ anchorDay }}</option>
        </select>
      </div>
      <div class="w-20">
        <div class="light-text">{{ 'profiles.edit.billing.starting-year' | translate | titlecase }}</div>
        <input class="form-control" [min]="1900" [max]="2100" type="number" [(ngModel)]="value.StartingYear"
          (change)="anchorChanged()" [disabled]="isLegacyArb" />
      </div>
    </div>
    <div>
      <div class="light-text">
        {{ 'profiles.edit.billing.billing-cycle' | translate | titlecase }}
      </div>
      <div>
        <select class="form-control" [(ngModel)]="value.BillingCycle" [disabled]="isLegacyArb"
          (change)="updateYearlyTotal()">
          <option value="0">{{ 'common.select' | translate | titlecase }}</option>
          <option *ngFor="let billingCycle of billingCycles" [value]="billingCycle.Name">{{ billingCycle.Name }}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div class="w-100 flex column gap-27px">
    <div>
      <div class="light-text">
        {{ 'common.revenue.amount' | translate | titlecase }}
      </div>
      <div class="mct-flex mct-col mct-gap-27" *ngIf="itemHasArc">
        <div>
          <p-checkbox [binary]="true" [(ngModel)]="useArc" [disabled]="isLegacyArb"></p-checkbox>
          <label class="mb-0 ml-4">{{ 'profiles.edit.billing.pricing-calculation-long' | translate }}</label>
          <select class="form-control mt-4" [(ngModel)]="arcId" [disabled]="!useArc || isLegacyArb"
            (change)="arcChanged($event.target.value)">
            <option value="0">{{ 'common.select' | translate | titlecase }}</option>
            <option value="0" *ngFor="let formula of arcFormulas" [value]="formula.ArcID"
              [hidden]="formula.ItemNum != value.ItemNum">
              {{ formula.Descr }}
            </option>
          </select>
        </div>
        <div class="flex space-around f-wb mb-27 w-100">- {{ 'common.or' | translate |
          uppercase }} -</div>
      </div>
      <div class="mt-10 grid cols-1fr-1fr gap-27px">
        <div class="w-100">
          <div class="light-text">{{ 'profiles.edit.billing.unit-price' | translate | titlecase }}</div>
          <div class="input-group">
            <wl-currency-symbol class="input-group-addon"></wl-currency-symbol>
            <input class="form-control" [(ngModel)]="value.UnitPrice" [disabled]="useArc || isLegacyArb"
              mask="separator.2" thousandSeparator="," (change)="updateYearlyTotal()" />
          </div>
        </div>
        <div class="w-100">
          <div class="light-text">{{ 'common.revenue.quantity' | translate | titlecase }}</div>
          <input class="form-control" [(ngModel)]="value.Quantity" [disabled]="useArc || isLegacyArb" mask="0*"
            (change)="updateYearlyTotal()" />
        </div>
        <div class="w-100">
          @if (!showBaseField) {
          <a class="flex" (click)="showBaseField = true">{{
            'profiles.edit.billing.add-a-base-price' | translate | ucfirst
            }}</a>
          }
          <div class="flex column" [hidden]="!showBaseField">
            <div class="light-text">{{ 'profiles.edit.billing.base-price' | translate | titlecase }}</div>
            <div class="input-group">
              <wl-currency-symbol class="input-group-addon"></wl-currency-symbol>
              <input class="form-control" [(ngModel)]="value.BasePrice" [disabled]="useArc || isLegacyArb"
                mask="separator.2" thousandSeparator="," name="basePrice" (change)="updateYearlyTotal()" />
            </div>
          </div>
        </div>
        <div class="w-100">
          @if (!showFlatFeeField) {
          <a class="flex" (click)="showFlatFeeField = true">{{
            'profiles.edit.billing.add-a-flat-fee' | translate | ucfirst
            }}</a>
          }
          <div class="flex column" [hidden]="!showFlatFeeField">
            <div class="light-text">{{ 'profiles.edit.billing.flat-fee' | translate | titlecase }}</div>
            <div class="input-group">
              <wl-currency-symbol class="input-group-addon"></wl-currency-symbol>
              <input class="form-control" [(ngModel)]="value.FlatFee" [disabled]="useArc || isLegacyArb"
                mask="separator.2" thousandSeparator="," (change)="updateYearlyTotal()" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mv-27 yearly-total">
      <div class="flex space-around">
        {{ 'profiles.edit.billing.yearly-total' | translate | ucfirst }}: {{ value.YearlyAmount | currency }}
      </div>
    </div>
  </div>
</div>
<hr />
<h4>{{ 'profiles.edit.billing.options' | translate | titlecase }}</h4>
<div class="w-100 mt-27 grid cols-1fr-1fr-collapse gap-27px">
  <div class="w-100 flex column nowrap gap-27px">
    <div>
      <div class="mb-5">
        <p-checkbox [binary]="true" [(ngModel)]="value.BillingExpires" [disabled]="isLegacyArb"> </p-checkbox>
        <label class="ml-4">{{ 'profiles.edit.billing.billing-expires-long' | translate }}</label>
      </div>
      <wl-date-selector *ngIf="value.BillingExpires" appendTo="body" [(ngModel)]="value.BillingExpireDate">
      </wl-date-selector>
    </div>
    <div>
      <div class="flex row-collapse wrap">
        <div class="mr-27">
          <p-checkbox [binary]="true" [(ngModel)]="value.BillManually" [disabled]="isLegacyArb"></p-checkbox>
          <label>
            {{ 'profiles.edit.billing.bill-manually' | translate | titlecase }}
          </label>
        </div>
        <div>
          <p-checkbox [binary]="true" [(ngModel)]="value.InvoiceSeparately" [disabled]="isLegacyArb"></p-checkbox>
          <label>
            {{ 'profiles.edit.billing.invoice-separately' | translate | titlecase }}
          </label>
        </div>
      </div>
      <div class="mt-27 mct-flex mct-row">
        <p-checkbox [binary]="true" [(ngModel)]="value.AllowPortalArbSubscription"></p-checkbox>
        <label class="ml-5 mb-0">{{ 'profiles.edit.billing.allow-portal-arb' | translate }} </label>
      </div>
    </div>
    <div class="w-100">
      <div class="light-text">{{ 'profiles.edit.billing.billing-notes' | translate | titlecase }}</div>
      <textarea [(ngModel)]="value.Notes" class="form-control" style="min-height: 72px"></textarea>
    </div>
  </div>
  <div class="w-100 mct-flex mct-col mct-gap-27">
    <div *ngIf="arbIsEnabled" class="w-100">
      <div class="mct-flex mct-col"
        [title]="arbStartDate < today ? ('profiles.edit.billing.past-arb' | translate) : (arbUnavailable && !gatewayArbId ? ('profiles.edit.billing.arb-unavailable' | translate) : '')">
        <div class="mct-flex mct-row">
          <p-checkbox [binary]="true" [(ngModel)]="arbSelected"
            [disabled]="arbStartDate < today || gatewayArbId || arbUnavailable"></p-checkbox>
          <label class="ml-4 mb-0">{{ 'profiles.edit.billing.set-as-arb' | translate }}</label>
        </div>
        <div [hidden]="!gatewayArbId" class="ml-27">
          <div class="light-text">
            {{ 'profiles.edit.billing.arb-subscription' | translate }}
          </div>
          <div>
            {{ gatewayArbId }}
          </div>
        </div>
      </div>
      <div [hidden]="!arbSelected || gatewayArbId">
        <div class="mv-27">
          <label class="light-text">{{ 'profiles.edit.billing.payment-type' | translate | titlecase }}</label>
          <select class="form-control" [(ngModel)]="selectedPaymentTypeId"
            (change)="selectedPaymentTypeChanged($event.target.value)">
            <option value="0">{{ 'common.select' | translate | titlecase }}</option>
            <option *ngFor="let type of arbPaymentTypes" [value]="type.PaymentTypeId">{{ type.PaymentType }}</option>
          </select>
        </div>
        <wl-credit-card-input *ngIf="showCCPayment" [defaultBillingAddress]="defaultBillingAddress"
          [resolvedGateway]="resolvedGateway" #creditCardInputComponent>
        </wl-credit-card-input>
        <wl-ach-input *ngIf="showACHPayment" [profileNames]="profileNames"
          [defaultBillingAddress]="defaultBillingAddress" [resolvedGateway]="resolvedGateway"
          (achInfoChanges)="updateACHInfo($event)">
        </wl-ach-input>
      </div>
    </div>
  </div>
</div>
<hr />
<p-accordion [value]="0">
  <p-accordion-panel [value]="1">
    <p-accordion-header (click)="showOverrides = !showOverrides">
      @if (!showOverrides) {
      <span class="pi pi-plus mr-5" style="font-size: 18px"></span>
      {{'profiles.edit.billing.expand-invoice-overrides' | translate | titlecase}}
      }
      @if (showOverrides) {
      <span class="pi pi-minus mr-5" style="font-size: 18px"></span>
      {{'profiles.edit.billing.close-invoice-overrides' | translate | titlecase}}
      }
    </p-accordion-header>
    <p-accordion-content>
      <div class="grid cols-1fr-1fr-collapse gap-27px w-100">
        <div class="flex column gap-27px w-100">
          <div class="w-100">
            <div class="light-text">{{ 'profiles.edit.billing.billing-descr' | translate | ucfirst }}</div>
            <input type="text" [(ngModel)]="value.Descr" class="form-control" />
          </div>
          <div class="w-100">
            <div class="light-text mb-0">{{ 'profiles.edit.billing.billing-contact' | translate | ucfirst }}</div>
            <p-select name="communicateWith" placeholder="{{ 'common.select' | translate | titlecase }}"
              optionValue="RelProfileID" optionLabel="ReportName" [options]="relatedProfiles"
              [(ngModel)]="value.CommunicateWithProfileID" [style]="{ width: '100%', height: '36px' }"></p-select>
          </div>
          <div class="w-100">
            <div class="light-text">{{ 'profiles.edit.billing.attention' | translate | ucfirst }}</div>
            <input type="text" [(ngModel)]="value.Attention" class="form-control" />
          </div>
          <div class="w-100">
            <div class="light-text">{{ 'profiles.edit.billing.sold-by' | translate | titlecase }}</div>
            <p-select name="soldBy" placeholder="{{ 'common.none' | translate | titlecase }}" optionValue="UserNum"
              optionLabel="UserName" [options]="allActiveUsers" [(ngModel)]="value.SoldBy"
              [style]="{ width: '100%', height: '36px' }" showClear></p-select>
          </div>
        </div>
        <div class="flex column gap-27px w-100">
          <div class="flex column">
            <label class="light-text mb-0">
              {{ 'profiles.edit.billing.billing-address-override' | translate | titlecase }}
            </label>
            <p-select name="soldBy" placeholder="{{ 'common.none' | translate | titlecase }}"
              [options]="profileAddressSelectItems" [style]="{ width: '100%', height: '36px' }"
              (onChange)="addressTypeChanged($event.value)">
            </p-select>
          </div>
          <div>
            <label class="light-text text mb-0">
              {{ 'profiles.edit.billing.billing-to-name' | translate | titlecase }}
            </label>
            <div>
              <input type="text" name="billToName" class="form-control" [(ngModel)]="value.BTName" />
            </div>
          </div>
          <div>
            <label class="light-text text mb-0">
              {{ 'common.personal-information.address1' | translate | titlecase }}
            </label>
            <div>
              <input type="text" name="btAddress1" class="form-control" [(ngModel)]="value.BTAddress1" />
            </div>
          </div>
          <div>
            <label class="light-text text mb-0">
              {{ 'common.personal-information.address2' | translate | titlecase }}
            </label>
            <div>
              <input type="text" name="btAddress2" class="form-control" [(ngModel)]="value.BTAddress2" />
            </div>
          </div>
          <div class="flex row-collapse gap-27px space-between">
            <div class="w-60">
              <label class="light-text mb-0">{{ 'common.personal-information.city' | translate | titlecase }}</label>
              <input class="form-control" type="text" [(ngModel)]="value.BTCity" />
            </div>
            <div>
              <div>
                <label class="light-text text mb-0"> {{ 'profiles.edit.general-information.state' | translate }}</label>
              </div>
              <wl-state-selector-modern [(selectedState)]="value.BTState"></wl-state-selector-modern>
            </div>
          </div>
          <div class="flex row-collapse space-between gap-27px">
            <div>
              <label class="light-text mb-0">{{ 'profiles.edit.general-information.zip' | translate }}</label>
              <input class="form-control" type="text" [(ngModel)]="value.BTZip" />
            </div>
            <div class="w-60">
              <label class="light-text mb-0">{{ 'common.personal-information.country' | translate | titlecase }}</label>
              <input class="form-control" type="text" [(ngModel)]="value.BTCountry" />
            </div>
          </div>
        </div>
      </div>
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>

<p-dialog modal="true" [(visible)]="showAnchorChangeWarning" [closable]="false" [showHeader]="false" styleClass="atlas-dialog-s" [focusOnShow]="false">
  <p>{{ 'profiles.edit.billing.anchor-change-warning' | translate }}</p>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="cancelAnchorChange()">{{ 'common.cancel' | translate | uppercase }}</button>
    <button pButton type="button" class="btn btn-primary" (click)="confirmAnchorChange()">{{ 'profiles.edit.billing.anchor-change-proceed' | translate }}</button>
  </ng-template>
</p-dialog>

<p-dialog modal="true" [(visible)]="showAnchorPastBlocked" [closable]="false" [showHeader]="false" styleClass="atlas-dialog-s" [focusOnShow]="false">
  <p>{{ 'profiles.edit.billing.anchor-past-blocked' | translate }}</p>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="btn btn-primary" (click)="acknowledgeAnchorPastBlocked()">{{ 'profiles.edit.billing.anchor-past-ok' | translate }}</button>
  </ng-template>
</p-dialog>
